<template>
  <section
    class="bg-white sm:text-left shadow-xl rounded-xl sm:w-full sm:p-10 sm:flex sm:flex-col sm:h-full p-2"
  >
    <h3 class="sm:text-xl font-bold text-base sm:mb-4">
      {{ title }}
    </h3>
    <apexchart
      type="pie"
      height="95%"
      width="100%"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </section>
</template>

<script>
import apexChartResizeFix from "@/mixins/apexChartResizeFix";

export default {
  mixins: [apexChartResizeFix],
  props: {
    title: {
      type: String,
      default: "Pie Chart Title",
    },
    data: {
      type: [],
      required: true,
    },
    labels: {
      type: [],
      default: () => {
        return [
          " INCONFORMIDADES CON INTERVENCIÓN DE ENTES DE CONTROL",
          " INCONFORMIDADES SIN  INTERVENCIÓN DE ENTES DE CONTROL",
        ];
      },
    },
    chartColors: {
      type: Array,
      default: () => undefined,
    },
  },
  data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: "100%",
          width: "100%",
          type: "pie",
        },
        noData: {
          text: "No hay datos para graficar",
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "24px",
            fontFamily: undefined,
          },
        },
        labels: [],
        plotOptions: {
          pie: {
            dataLabels: {
              offset: -7,
            },
          },
        },
        legend: {
          show: true,
          position: "bottom",
          horizontalAlign: "left",
          width: 400,
          fontSize: "14px",
          itemMargin: {
            horizontal: 5,
            vertical: 5,
          },
          formatter: function (val, opts) {
            const series = opts.w.config.series || [];
            const total = series.reduce((acc, n) => acc + (Number(n) || 0), 0);
            const pct =
              total > 0
                ? (
                    (opts.w.globals.series[opts.seriesIndex] * 100) /
                    total
                  ).toFixed(2)
                : "0.00";
            return val + " ( " + pct + " % )";
          },
        },
        responsive: [
          {
            breakpoint: 600,
            options: {
              chart: {
                width: "100%",
                height: "100%",
              },
              legend: {
                position: "bottom",
                fontSize: "14px",
              },
            },
          },
        ],
        dataLabels: {
          formatter(val, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          },
        },

        theme: {
          monochrome: {
            enabled: true,
            color: "#004884",
          },
        },
      },
    };
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        this.updateChartData();
      },
      deep: true,
    },
    labels: {
      handler(newVal, oldVal) {
        this.updateChartData();
      },
      deep: true,
    },
    chartColors: {
      handler(newVal, oldVal) {
        this.updateChartData();
      },
      deep: true,
    },
  },
  created() {
    this.updateChartData();
  },
  methods: {
    updateChartData() {
      const data = Array.isArray(this.data) ? this.data : [];
      const labels = Array.isArray(this.labels) ? this.labels : [];
      this.series = data.length ? [...data] : [];
      this.chartOptions.labels = labels.length ? [...labels] : [];

      const useCustomColors =
        this.chartColors &&
        Array.isArray(this.chartColors) &&
        this.chartColors.length > 0;
      this.chartOptions.colors = useCustomColors ? this.chartColors : undefined;
      this.chartOptions.theme.monochrome.enabled = !useCustomColors;
    },
  },
};
</script>
